export default "__VITE_ASSET__DT2CO4gW__"